
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPaymentIconsAttach = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 32,
  viewBox: "0 0 38 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.345 8.118 11.818 18.836a3.685 3.685 0 0 0-1.023 2.619 3.686 3.686 0 0 0 3.75 3.654 3.672 3.672 0 0 0 2.605-1.077l11.345-11.346a6.45 6.45 0 0 0 1.896-4.568 6.452 6.452 0 0 0-6.518-6.436 6.49 6.49 0 0 0-4.555 1.882L8.286 14.636a9.163 9.163 0 0 0-2.726 6.505 9.202 9.202 0 0 0 9.232 9.177 9.164 9.164 0 0 0 6.504-2.727l9.028-9.014",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.8,
  fill: "none",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"38\" height=\"32\" viewBox=\"0 0 38 32\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.8\">\r\n            <g>\r\n                <path d=\"M17.345 7.118L6.818 17.836c-.674.703-1.041 1.645-1.023 2.619.008.983.408 1.923 1.113 2.61.704.686 1.654 1.062 2.637 1.044.977.002 1.915-.386 2.605-1.077l11.345-11.346c1.214-1.21 1.896-2.854 1.896-4.568-.004-1.72-.694-3.367-1.918-4.576-1.224-1.209-2.88-1.878-4.6-1.86-1.707.004-3.343.68-4.555 1.882L3.286 13.636C1.546 15.354.564 17.696.56 20.141c.007 2.441.984 4.78 2.715 6.5 1.732 1.722 4.076 2.684 6.517 2.677 2.445-.005 4.787-.987 6.504-2.727l9.028-9.014\" transform=\"translate(5 1)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/payment-icons-attach.6ab2ab8a7c86cbdb2fef832a85d82251.svg"),
        {
          React: SvgPaymentIconsAttach,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      